import { styled, Theme } from "@mui/material/styles"

type DividerProps = {
  theme?: Theme;
  isFullWidth?: boolean;
}

const Divider = styled("div", {
  shouldForwardProp: (prop) => prop !== "isFullWidth"
})<DividerProps>(({ theme, isFullWidth }) => ({
  width: isFullWidth ? "100%" : "85%",
  height: "1px",
  backgroundColor: theme?.palette.gray["5"],
  margin: "0 auto"
}))

export default Divider
